import React from 'react'
import SearchPatient from '../components/patientSearch/SearchPatient'
import PatientDetails from '../components/patientSearch/PatientDetails'
import PatientCard from '../components/patientSearch/PatientCard'
import { useSelector } from 'react-redux'
import Loader from '../components/menu/Loader'

function PatientSearch({ value }) {
    const patientAppList = useSelector((state) => state.patientApplicationListSlice);
    const searchPatient = useSelector((state) => state.patientSearchSlice);
    const showLoader = useSelector((state)=>state.patientCaseListSlice.loader)
    const loader = useSelector((state)=>state.generateHashDataSlice.loader)

    return (
        <div className="g-col-12 intro-y box py-1 py-sm-4 mt-10">
            { (showLoader || loader) ? <Loader /> : null}
            <SearchPatient value={value} />
            <div className=" intro-y box">
                <PatientDetails value={value} />
                {searchPatient.displayPatientCard && <PatientCard value={value} />}
            </div>
        </div>
    )
}

export default PatientSearch